import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const Tips1Field: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	if (restaurantForFullInfo?.defaultTips[1]) {
		return (
			<FullInfoField
				label={restaurantForFullInfo.defaultTips[1].isDefault ? 'tips1DefaultLabel' : 'tips1Label'}
				value={restaurantForFullInfo.defaultTips[1].value}
			/>
		);
	}
	return <FullInfoField label="tips1Label" value={null} />;
};

export default Tips1Field;
